import {productGrid} from '../features/product-grid';
import {gridSlider} from '../features/grid-slider';
import {register} from '../vendor/theme-scripts/theme-sections';

register('featured-collection', [productGrid, gridSlider]);
